import DonorList from "./components/DonorList";

function App() {
  return (
    <div>
      <DonorList />
    </div>
  );
}

export default App;
